import React from 'react';
import moment from 'moment';

const dateFormat = 'YYYY-MM-DD';

const defaultDiaryContext = {
	startDate: null,
	endDate: null,
	selectedDate: moment().format(dateFormat),
	//selectedDate: '2020-03-07',
	period: 'month',
	data: [],
};

const diaryContext = React.createContext(defaultDiaryContext);

export {
	defaultDiaryContext,
	diaryContext,
};
